import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import { push } from 'connected-react-router';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import LspDelOrdIndexActions, { LspDelOrdIndexTypes } from '../Stores/LspDelOrdIndex/Actions';

const getAppStore = state => state.app;

export function* lspDelOrdIndexFetchLspDelOrdIndex({ currentPage, sorts, filters, pageSize }) {
  try {
    yield put(LspDelOrdIndexActions.lspDelOrdIndexFetchLspDelOrdIndexLoading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `lspDelOrd/index/${app.curDivisionId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        LspDelOrdIndexActions.lspDelOrdIndexFetchLspDelOrdIndexSuccess(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(LspDelOrdIndexActions.lspDelOrdIndexFetchLspDelOrdIndexLoading(false));
  }
}

export function* lspDelOrdIndexFetchLspDelOrdExportIndex({
  currentPage,
  sorts,
  filters,
  pageSize
}) {
  try {
    yield put(LspDelOrdIndexActions.lspDelOrdIndexFetchLspDelOrdIndexLoading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `lspDelOrd/export-index/${app.curDivisionId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        LspDelOrdIndexActions.lspDelOrdIndexFetchLspDelOrdIndexSuccess(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(LspDelOrdIndexActions.lspDelOrdIndexFetchLspDelOrdIndexLoading(false));
  }
}

export function* lspDelOrdIndexGoToDocument({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/lspDelOrdDetail/update/${hdrId}`));
}

export function* lspDelOrdIndexGoToAudit({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/auditResource/LSP_DEL_ORD/${hdrId}/LspDelOrdHdr`));
}

export function* lspDelOrdExportPurchaseInvoices({ selectedDocuments }) {
  try {
    yield put(LspDelOrdIndexActions.lspDelOrdIndexFetchLspDelOrdIndexLoading(true));

    const app = yield select(getAppStore);
    const postData = {
      hdr_ids: selectedDocuments,
      division_id: app.curDivisionId
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `lspDelOrd/export-to-pur-inv`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      yield put(LspDelOrdIndexActions.lspDelOrdIndexSetWorkspaceVisible(false));
      
      yield call(notification.success, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_SUCCESS_MESSAGE_DURATION, 10)
      });
      yield put(
        LspDelOrdIndexActions.lspDelOrdIndexFetchLspDelOrdExportIndex(
          1,
          { doc_code: 'descend' },
          {},
          10
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(LspDelOrdIndexActions.lspDelOrdIndexFetchLspDelOrdIndexLoading(false));
  }
}

export const saga = [
  takeLatest(
    LspDelOrdIndexTypes.LSP_DEL_ORD_INDEX_FETCH_LSP_DEL_ORD_INDEX,
    lspDelOrdIndexFetchLspDelOrdIndex
  ),
  takeLatest(
    LspDelOrdIndexTypes.LSP_DEL_ORD_INDEX_FETCH_LSP_DEL_ORD_EXPORT_INDEX,
    lspDelOrdIndexFetchLspDelOrdExportIndex
  ),

  takeLatest(LspDelOrdIndexTypes.LSP_DEL_ORD_INDEX_GO_TO_DOCUMENT, lspDelOrdIndexGoToDocument),
  takeLatest(LspDelOrdIndexTypes.LSP_DEL_ORD_INDEX_GO_TO_AUDIT, lspDelOrdIndexGoToAudit),
  takeLatest(
    LspDelOrdIndexTypes.LSP_DEL_ORD_EXPORT_PURCHASE_INVOICES,
    lspDelOrdExportPurchaseInvoices
  )
];
